import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { key: 2 }

import cvrUploadSummariesData from "@/types/responses/cvrUploadSummariesData"
import { CVR_UPLOAD_READY_STATUSES, DEVICE_TYPE_C500_ID } from "@/services/consts"
import { computed } from 'vue'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadStatus',
  props: {
    item: {},
    acordionItemStyle: {},
    openRequestModal: { type: Function }
  },
  setup(__props: any) {

const props = __props

const AVAILABLE_CVR_REQUEST_DEVICE_MODEL_TYPES = DEVICE_TYPE_C500_ID;

const uploadStatuses = computed(() => {
  if (CVR_UPLOAD_READY_STATUSES.includes(props.item.latest_status)) return i18n.global.t('pages.cvr_uploads.waitting')
  return ''
})

const displayRequestButton = computed(() => {
  return props.item.device_id && props.item.device_model_type == AVAILABLE_CVR_REQUEST_DEVICE_MODEL_TYPES
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (uploadStatuses.value)
    ? (_openBlock(), _createElementBlock("td", {
        key: 0,
        style: _normalizeStyle(props.acordionItemStyle),
        class: "text-center"
      }, _toDisplayString(uploadStatuses.value), 5))
    : (displayRequestButton.value)
      ? (_openBlock(), _createElementBlock("td", {
          key: 1,
          style: _normalizeStyle(props.acordionItemStyle)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_btn, {
              id: "requestModalButton",
              class: "exec-btn px-8",
              onClick: props.openRequestModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.requestBtn')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 4))
      : (_openBlock(), _createElementBlock("td", _hoisted_2))
}
}

})